export enum PlanStatusEnum {
  NEW = 'NEW',
  IN_AGREEMENT = 'IN_AGREEMENT',
  IN_REVISION = 'IN_REVISION',
  AGREED = 'AGREED',
  APPROVED = 'APPROVED',
}
